import gql from "graphql-tag";

export const GET_ACCOUNT = gql`
    query Account($accountId: ID!){
        account(accountId: $accountId) {
            accountId
            userId
            accountName
            displayName
            accountDescription
            accountLinkedinId
            createdAt
            updatedAt
            deleted
            deletedAt
            tagLinks {
                tagId
                tag {
                    tag
                }
            }
            tags {
                tag
            }
        }
    }
`;

export const GET_ACCOUNT_BY_LINKEDIN_ID = gql`
    query AccountByLinkedinId($accountLinkedinId: ID!){
        accountByLinkedinId(accountLinkedinId: $accountLinkedinId) {
            accountId
            userId
            accountName
            displayName
            accountDescription
            accountLinkedinId
            createdAt
            updatedAt
            deleted
            deletedAt
            tags {
                tag
            }
        }
    }
`;

// export const GET_ACCOUNT_OF_ORGANIZATION = gql`
//     query AccountOfOrganization($organizationId: ID!){
//         accountOfOrganization(organizationId: $organizationId) {
//             accountId
//             organizationId
//             userId
//             accountName
//             displayName
//             accountDescription
//             accountLinkedinId
//             createdAt
//             updatedAt
//             deleted
//             deletedAt
//             tagLinks {
//                 tagId
//                 tag {
//                     tag
//                 }
//             }
//             tags {
//                 tag
//             }
//         }
//     }
// `;

export const GET_ACCOUNTS = gql`
    query Accounts($searchStr: String, $filterSQL: String, $limit: Int, $offset: Int, $orderList: [String]){
        accounts(searchStr: $searchStr, filterSQL: $filterSQL, limit: $limit, offset: $offset, orderList: $orderList) {
            count
            rows {
                accountId
                userId
                accountName
                displayName
                accountDescription
                accountLinkedinId
                createdAt
                updatedAt
                deleted
                deletedAt
                tagLinks {
                    tagId
                    tag {
                        tag
                    }
                }
                tags {
                    tag
                }
            }
        }
    }
`;

export const GET_ACCOUNTS_BY_NAME = gql`
    query AccountsByName($searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        accountsByName(searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            accountId
            accountName
            displayName
        }
    }
`;

export const GET_ACCOUNTS_FIND_SIMILAR_NAMES = gql`
    query AccountsFindSimilarNames($name: String, $limit: Int, $offset: Int, $orderList: [String]){
        accountsFindSimilarNames(name: $name, limit: $limit, offset: $offset, orderList: $orderList) {
            accountId
            accountName
            displayName
        }
    }
`;

export const GET_ACCOUNTS_EXPORT = gql`
    query AccountsExport($accountIds: [ID!]!){
        accountsExport(accountIds: $accountIds) {
            accountId
            userId
            accountName
            displayName
            accountDescription
            accountLinkedinId
            createdAt
            updatedAt
            deletedAt
            tags {
                tag
            }
            emailAddresses {
                emailAddressType
                emailAddress
                primary
                optedOut,
                optedOutAt,
            }
            phoneNumbers {
                phoneNumberType
                phoneNumber
                primary
            }
            mailAddresses {
                mailAddressType
                fullAddress
                address1
                address2
                city
                state
                postalCode
                country
                primary
            }
        }
    }
`;

export const CREATE_ACCOUNT = gql`
    mutation CreateAccount($newAccount: newAccount!) {
        createAccount(
            newAccount: $newAccount
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_ACCOUNT = gql`
    mutation UpdateAccount($changedAccount: changedAccount!) {
        updateAccount(
            changedAccount: $changedAccount
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const DELETE_ACCOUNT = gql`
    mutation DeleteAccount($accountId: ID!) {
        deleteAccount(
            deleteAccountId: $accountId
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_ACCOUNTS = gql`
    mutation DeleteAccounts($deleteAccountIds: [ID!]!) {
        deleteAccounts(
            deleteAccountIds: $deleteAccountIds
        ) {
            returnCode
            message
        }
    }
`;

export const MERGE_ACCOUNTS = gql`
    mutation MergeAccounts($mainAccountId: ID!, $mergeAccountIds: [ID!]!) {
        mergeAccounts(
            mainAccountId: $mainAccountId,
            mergeAccountIds: $mergeAccountIds
        ) {
            returnCode
            message
        }
    }
`;

export const ADD_TAGS_TO_ACCOUNTS = gql`
    mutation AddTagsToAccounts($accountIdList: [ID!]!, $tagObjList: tagObjList!) {
        addTagsToAccounts(
            accountIdList: $accountIdList
            tagObjList: $tagObjList
        ) {
            returnCode
            message
        }
    }
`;

export const REMOVE_TAGS_FROM_ACCOUNTS = gql`
    mutation RemoveTagsFromAccounts($accountIdList: [ID!]!, $tagObjList: tagObjList!) {
        removeTagsFromAccounts(
            accountIdList: $accountIdList
            tagObjList: $tagObjList
        ) {
            returnCode
            message
        }
    }
`;
